import React from "react";

interface Props {
  className?: string;
  style?: React.CSSProperties;
}

const HexIcon: React.FC<Props> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    {...props}
  >
    <path
      transform="translate(0.000000, 1.000000)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M14 10 m0 0 m2 1 M20 7 l-2-1 m2 1 v2.5 M14 4 l-2-1-2 1 M4 7 l2-1 M4 7 M4 7 v2.5 M12 21 l-2-1 m2 1 l2-1 m-2 1 M6 18 l-2-1 v-2.5 M18 18 l2-1 v-2.5"
    />
  </svg>
);

export default HexIcon;
